import React, { Component } from 'react';
import { render } from 'react-dom';
import { Provider, connect } from 'react-redux'

import { store } from './Store';

import App from './Components/App/';

const Root = ({store, history}) => (
  <Provider store={ store }>
    <App {...{ history }} />
  </Provider>
)

render(<Root store={ store } />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js